/**
*
* Disclaimer: Source code mentioned below is(are) Intellectual Property of
* Crayon Data Holdings Limited (including its subsidiaries and affiliates).
* Crayon Data Holdings Limited reserves right to own and control it the way
* it may deem fit. You must refrain from use, access, read, modify, add or
* delete, sell or use in any other package or programme pertaining to such
* source code without explicit prior written approval of
* Crayon Data Holding Limited. Breach of the same shall attract penalty as
* applicable.
*
*/

import React, { useState } from "react";

import { interaction, getError } from "../../service";
import { arabicContent } from "../../constants/index";

const SettingModal = ({ hide, item, likeState, dislikeState, onTypeLikeChange, onTypeDislikeChange }) => {

  const onHandlerLikeChange = e => {
    e.stopPropagation();
    onTypeLikeChange(e.target.value);
  }

  const onHandlerDislikeChange = e => {
    e.stopPropagation();
    onTypeDislikeChange(e.target.value);
  }

  const onHandlerLikeClick = e => {
    if (!likeState) {
      e.stopPropagation();
      if (e.target.nextSibling?.value) {
        onTypeLikeChange(e.target.nextSibling.value);
      }
    }
  }

  const onHandlerDislikeClick = e => {
    if (!dislikeState) {
      e.stopPropagation();
      if (e.target.nextSibling?.value) {
        onTypeDislikeChange(e.target.nextSibling.value);
      }
    }
  }

  let lang = localStorage.getItem("language");

  return (
    <>
      <div className={`cursor ${likeState ? "radiotext-like chkd" : "radiotext-like"}`} onClick={onHandlerLikeClick} >
        <span>{lang === 'AR' ? arabicContent.adblike : `Show more like this`}</span>
        <input
          type="radio"
          className="likeradio"
          name="like"
          value="LIKE"
          onChange={onHandlerLikeChange}
          checked={likeState}
        />
      </div>

      <div className={`cursor ${dislikeState ? "radiotext-dislike chkd" : "radiotext-dislike"}`} onClick={onHandlerDislikeClick} >
        <span>{lang === 'AR' ? arabicContent.dislike : `Not Interested`}</span>
        <input
          className="dislikeradio"
          type="radio"
          name="dislike"
          value="DISLIKE"
          onChange={onHandlerDislikeChange}
          checked={dislikeState}
        />
      </div>
    </>
  );
};

export default SettingModal;